<template>
  <div class="history-page">
    <div class="history-page-navigate position-relative">
      <video src="../../assets/source/bg-video.mp4" muted loop autoplay />
      <div class="history-page-navigate-body position-relative">
        <div class="history-page-navigate-body-content safe-with">
          <p class="font-bold font-36 font-color-fff">光辉事迹</p>
        </div>
      </div>
    </div>
    <div v-if="cateAry.length" class="history-page-list">
      <div class="history-page-list-body safe-with flex">
        <div class="history-page-list-body-left flex-shrink">
          <div class="history-page-list-body-left-body">
            <div v-for="(item, index) in cateAry" :key="index" class="history-page-list-body-left-body-item flex-row-center cursor" :class="cateId==item.code?'sel':''" @click="newCateTap(item)">
              <p class="font-14">{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="history-page-list-body-right flex-1">
          <div class="history-page-list-body-right-tit flex-row-center-between">
            <p class="font-bold font-16">{{ getCateName(cateId) }}</p>
            <p />
          </div>
          <div v-if="cateId == 1">
            <person-info />
          </div>
          <div v-else-if="cateId == 2">
            <person-map />
          </div>
          <div v-else>
            <div v-if="list.length">
              <div class="history-page-list-body-right-list">
                <div v-for="(item, index) in list" :key="index" class="history-page-list-body-right-list-item flex" @click="checkDetail">
                  <div class="date flex-row-center flex-shrink">
                    <p class="font-color-fff font-12">{{ item.startDate }}</p>
                  </div>
                  <div class="info flex-1">
                    <p class="tit font-14">{{ item.name }}</p>
                    <div v-if="item.resourceInfo && item.resourceInfo.files" class="source-img flex">
                      <div v-for="(s, sindex) in item.resourceInfo.files" :key="sindex" class="item flex-center cursor" @click="checkImg(index,sindex)">
                        <div v-if="s.coverImage" class="img flex-center" :style="{backgroundImage: 'url(' + s.coverImage + ')', width: s.createUser + 'px'}">
                          <img class="cursor" src="@/assets/img/icon-history-check.png">
                        </div>
                        <div v-else class="default-img-cover flex-center">
                          <img class="cursor" src="@/assets/img/icon-history-check.png">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="history-page-list-body-right-error flex-column-center">
              <img src="@/assets/img/icon-list-error.png">
              <p class="font-14 font-color-999">暂无数据</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/index.js'
import personInfo from './components/info/index.vue'
import personMap from './components/map/index.vue'
import { getShowPath } from '@/utils/imgpath.js'
export default {
  components: {
    personInfo,
    personMap
  },
  data() {
    return {
      list: [],
      currPage: 1,
      pages: 0,
      cateIndex: 0,
      cateId: 0,
      cateAry: [],
      htmlStr: ''
    }
  },
  watch: {
    $route(to, from) {
      this.cateId = this.$route.query.cateId ?? 1
      if (this.cateId !== 1 && this.cateId !== 2) {
        this.request()
      }
    }
  },

  created() {
    this.cateId = this.$route.query.cateId || 1
    this.requestCatalog()
  },
  methods: {
    getCateName(val) {
      const value = this.cateAry.filter(v => v.code === val)
      if (value.length) {
        return value[0].name
      }
    },
    checkImg(val) {
      this.$router.push({
        path: '/source',
        query: {
          sourceId: this.list[val].resourceInfo.id,
          cateId: this.list[val].resourceInfo.catalogId
        }
      })
    },
    async requestCatalog() {
      const res = await api.getListByParentId({ parentId: 963 })
      if (res.code === 2000) {
        const ary = res.items
        this.cateAry = [{ code: 1, name: '生平简介' }, { code: 2, name: '人生轨迹' }].concat(ary)
      }
    },
    request() {
      api.getEventList({
        asc: 1,
        field: 'startDate',
        majorEvent: 1,
        majorEventType: this.cateId,
        limit: 100,
        page: 1
      }).then(res => {
        if (res.code === 2000) {
          console.error(res.items)
          res.items.data.forEach(v => {
            if (v.resourceInfo && v.resourceInfo.files) {
              const ary = v.resourceInfo.files.filter(i => i.coverImage !== '')
              ary.forEach(item => {
                if (item.coverImage) {
                  item.coverImage = getShowPath('img', item.coverImage)
                  const image = new Image()
                  image.src = item.coverImage
                  image.onload = () => {
                    const hg = 150 * (image.width / image.height)
                    item.createUser = hg
                  }
                } else {
                  item.createUser = 300
                }
              })
              v.resourceInfo.files = ary
            }
          })
          this.list = res.items.data
          this.pages = res.items.totalCount
        }
      })
    },
    pageChage(v) {
      this.currPage = v
      this.request()
    },
    newCateTap(val) {
      if (val.code === this.cateId) {
        return
      }
      this.cateId = val.code
      this.$router.push({
        path: '/history',
        query: {
          cateId: val.code
        }
      })
    },
    checkDetail() {}
  }
}
</script>

<style lang="scss" scoped>
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   background-color: #B21F12;
 }

 /deep/.el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }

 /deep/.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
   min-width: 40px;
   border-radius: 5px;
 }
 /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
   color: #B21F12;
 }
 /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
   color: #fff;
 }

 /deep/.el-pagination.is-background .el-pager li.active {
   border: none;
 }

 /deep/.el-pagination.is-background .el-pager li {
   min-width: 40px !important;
   background-color: #fff;
   border: 1px solid #F7F7F7;
 }
</style>

<style scoped>
  .history-page-navigate {
    background-image: url('../../assets/img/bg-notice-navigate.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 200px;
    margin-top: -60px;
  }

  .history-page-navigate video {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .history-page-navigate-body {
    height: 200px;
    z-index: 1;
  }

  .history-page-navigate-body-content {
    padding-top: 120px;
  }

  .history-page-navigate-body-content p {
    line-height: 80px;
  }

  .history-page-list-body-right {
    margin-left: 30px;
  }

  .history-page-list-body-right-tit {
    margin-top: 10px;
    height: 50px;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    border-color: #EEEEEE;
  }

  .history-page-list-body-right-tit p:last-child {
    color: #767676;
  }

  .history-page-list-body-left {
    width: 220px;
  }

  .history-page-list-body-right-list {
    padding-top: 30px;
    padding-bottom: 40px;
  }

  .history-page-list-body-right-list-item {
    margin-bottom: 30px;
  }

  .history-page-list-body-right-list-item:last-child {
    margin-bottom: 0;
  }

  .history-page-list-body-right-list-item .date {
    background-image: url('../../assets/img/icon-history-arrow.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 120px;
    height: 24px;
    margin-right: 20px;
    padding: 0 10px;
  }

  .history-page-list-body-right-list-item .info .tit {
    line-height: 24px;
    color: #3D3D3D;
  }

  .history-page-list-body-right-list-item .info .source-img {
    margin-top: 10px;
    flex-wrap: wrap;
  }

  .history-page-list-body-right-list-item .info .source-img .item {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .history-page-list-body-right-list-item .info .source-img .item .img {
    height: 150px;
    border-radius: 5px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .history-page-list-body-right-list-item .info .source-img .item .img img {
    opacity: 0;
  }

  .history-page-list-body-right-list-item .info .source-img .img:hover img {
    opacity: 1;
  }

  .history-page-list-body-right-list-page {
    margin: 60px 0;
  }

  .history-page-list-body-left-body {
    width: 100%;
    height: 400px;
    padding-top: 10px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.03) 100%);
  }

  .history-page-list-body-left-body-item {
    height: 50px;
    border-image: linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%) 0 0 1 0;
    border-width: 0px 0px 1px 0px;
    border-style: solid;
    padding: 0 20px;
  }

  .history-page-list-body-left-body-item.sel p{
    font-weight: bold;
  }

  .history-page-list-body-right-error {
    height: 500px;
    justify-content: center;
  }

  .history-page-list-body-right-error img {
    margin-bottom: 10px;
  }

</style>
